import React, { useContext } from "react";
import PropTypes from "prop-types";
// import { useTranslation } from "react-i18next";

import {
  getDetails,
  getURL,
} from "../../../Library/components/Project/components/Preview/utilities";
import { resolveAndPlay, resolveLink } from "../../../../../utilities/secureVideo";
import { libraryContent } from "../../../../../activity/content";
import classes from "./Preview.module.scss";
import cs from "classnames";
import { observer } from "mobx-react-lite";
import { StoreContext } from "../../../../../contexts";
import Icon from "../../../../atoms/Icon";
import { APPLICATION_ROUTES } from "../../../../../constants";
import {
  formatJewishDate,
} from "../../../../../utilities/helpers";
import { isMobile } from "react-device-detect";
import PreviewFooter from "../../../../atoms/PreviewFooter";
import { useParams } from "react-router-dom/cjs/react-router-dom";
// import { NavLink } from 'react-router-dom/cjs/react-router-dom';

const isBase64 = (str) => {
  try {
    const decodedStr = atob(str);
    const lowerDecodedStr = decodedStr.toLowerCase();
    return ["k", "d", "i"].some((prefix) =>
      lowerDecodedStr.startsWith(prefix)
    );
  } catch (err) {
    return false;
  }
};

const Preview = observer(
  ({
    locales,
    categories,
    questions,
    tags,
    file,
    holiday,
    placeholder,
    internal_id,
    onSelect,
    videoAction,
    videoInfo,
    setMainAudio,
    popupKids,
    audioAuthKidsPopup,
    // videoCount,
  }) => {
    // const {
    //   // t,
    //   i18n: { language },
    // } = useTranslation();
    const { playlist, authorization, common } = useContext(StoreContext);
    const videoParamsTest = useParams();

    const submitAnswer = (e) => {
      playlist.setCurrentPlayingVideoId(details.id);
      resolveAndPlay({
        details,
        onSelect,
        buildPayload: (resolvedLink) => ({
          end: details.end_time,
          start: details.start_time,
          url: getURL(resolvedLink, { start: details.start_time }),
          name: details.name,
          description: details.description,
          number: details.number,
          categories: categories,
          questions: questions,
          tags: tags,
          holiday: holiday,
          date: details.created_at,
          file: file,
          free_everywhere: details?.free_everywhere,
        }),
        on401: () => audioAuthKidsPopup?.onOpen(),
        on403: () => popupKids?.onOpen(),
      });
      videoAction.showQuestionScreen(e);
    };

    const sharePage = async () => {
      const shareData = {
        url: window.location.origin + "/" + details.video_url,
        title: details.title,
      };

      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(JSON.stringify({
          type: 'SHARE',
          payload: shareData
        }));
        return;
      }

      try {
        if (navigator.share) {
          await navigator.share(shareData);
        } else {
          console.warn("Web Share API not supported in this browser");
        }
      } catch (e) {
        console.error(e);
      }
    };

    // const details = getDetails(language, locales);
    const details = getDetails("en", locales);

    console.log("details", details?.duration_formatted);

    // let time = new Date();
    let time = new Date(
      details.showing_date == null
        ? details.created_at
        : details.showing_date + " 00:00:00"
    );
    time = formatJewishDate(time, false, true);

    // const navigateToLibrary = () => {
    //   history.push(APPLICATION_ROUTES.LIBRARY);
    //   scrollToTop();
    // };

    const downloadFile = (url) => {
      window.open(url);
    };

    const pdfHandler = () => {
      if (authorization.isAuthenticated) {
        downloadFile(file);
      } else {
        if (!location.pathname.includes(APPLICATION_ROUTES.LIBRARY_PROECTED)) {
          playlist.setCurrentPlayingVideoId(details.id);
          resolveAndPlay({
            details,
            onSelect,
            buildPayload: (resolvedLink) => ({
              end: details.end_time,
              start: details.start_time,
              url: getURL(resolvedLink, {
                start: details.start_time,
              }),
              name: details.name,
              description: details.description,
              number: details.number,
              categories: categories,
              questions: questions,
              tags: tags,
              holiday: holiday,
              date: details.created_at,
              file: details.file,
              internal_id: internal_id,
              free_everywhere: details?.free_everywhere,
            }),
            on401: () => audioAuthKidsPopup?.onOpen(),
            on403: () => popupKids?.onOpen(),
          });
        }
      }
    };

    //   const isCurrentAudioPlaying =
    // audioHandler?.currentAudio?.id === `audio-${videoInfo?.id}`;

    // Handle audio playback: like a video, a restricted audio's link comes from the API,
    // which checks the member's access
    const handleAudioClick = async () => {
      const link = await resolveLink({
        details,
        on401: () => audioAuthKidsPopup?.onOpen(),
        on403: () => popupKids?.onOpen(),
      });
      if (link === null) return;

      setMainAudio({
        musicSrc: link,
        name: details.name,
        id: `audio-${details.id}`,
        index: details.id,
        value: link,
        cover: details.thumbnail,
        // The library content playing, which the player reports the member's activity for.
        activity: libraryContent("audio", details),
      });
    };

    // Handle video playback (existing logic)
    const handleVideoClick = () => {
      playlist.setCurrentPlayingVideoId(details.id);
      resolveAndPlay({
        details,
        onSelect,
        buildPayload: (resolvedLink) => ({
          end: details.end_time,
          start: details.start_time,
          url: getURL(resolvedLink, { start: details.start_time }),
          name: details.name,
          description: details.description,
          number: details.number,
          categories: categories,
          questions: questions,
          tags: tags,
          holiday: holiday,
          date: details.created_at,
          file: file,
          internal_id: internal_id,
          free_everywhere: details?.free_everywhere,
        }),
        on401: () => audioAuthKidsPopup?.onOpen(),
        on403: () => popupKids?.onOpen(),
      });
    };
    let audioPlayer = document.querySelector(".music-player-audio");


    // Determine which click handler to use based on media type
    const handlePreviewClick = () => {
      let allowMediaPlay = false;

      if (isBase64(videoParamsTest.id)) {
        allowMediaPlay = true;
      } else if (details.require_membership_to_watch && !authorization.isUserMember) {
        popupKids.onOpen();
        return;
      } else if (details.require_login_to_watch && !authorization.isAuthenticated) {
        audioAuthKidsPopup.onOpen();
        return;
      } else {
        allowMediaPlay = true;
      }

      if (allowMediaPlay) {
        common.set('isAudioPlayerOpen', !common.get('isAudioPlayerOpen'))

        if (audioPlayer && audioPlayer.closest(".music-player-audio-preview")) {
          audioPlayer.togglePlay();
        } else {
          audioPlayer?.destroy();
        }

        // Check if it's audio type
        if (videoInfo?.media_type === "audio") {
          handleAudioClick();
        } else {
          // Default to video behavior
          handleVideoClick();
        }
      }

    };

    return (
      <div className={cs(classes.container, "bxsh-soft")}>
        <div className={cs(classes.previewContainer)}>
          {
            videoInfo?.media_type !== "audio" &&
            <div className={classes.videoInfoWrap}>
              <span className={classes.videoInfoText}>
                <strong>#{details.number}</strong> | {time}
              </span>
            </div>
          }
          <div
            className={cs(
              classes.preview,
              "curs-pointer",
              isMobile ? classes.previewMobile : ""
            )}
            role="button"
            style={{
              backgroundImage: `url(${details.thumbnail || placeholder})`,
            }}
            onClick={handlePreviewClick}
          >
            <div className={cs(classes.playerControlWrapper)}>
              {
                videoInfo?.media_type === "audio" ? (
                  <>
                    {common.get('isAudioPlayerOpen') ? <Icon className={cs(classes.playerPlay)} name='pause' /> : <Icon className={cs(classes.playerPlay)} name='new-play-icon' />}
                  </>
                ) : (
                  <Icon className={cs(classes.playerPlay)} name="new-play-icon" />
                )
              }

              {details.duration_formatted && (
                <span className={cs(classes.videoTime)}>
                  {details.duration_formatted}
                </span>
              )}
            </div>
          </div>
        </div>
        <div>
          <PreviewFooter
            videoAction={videoAction}
            videoInfo={videoInfo}
            sharePage={sharePage}
            submitAnswer={submitAnswer}
            file={file}
            pdfHandler={pdfHandler}
          />
        </div>
      </div>
    );
  }
);

Preview.propTypes = {
  id: PropTypes.string.isRequired,
  locales: PropTypes.shape({
    // en: PropTypes.shape({
    //   link: PropTypes.string.isRequired,
    // }),
  }).isRequired,
  placeholder: PropTypes.string.isRequired,
  onSelect: PropTypes.func.isRequired,
  videoAction: PropTypes.object,
  popupKids: PropTypes.object,
  audioAuthKidsPopup: PropTypes.object,
};

export default React.memo(Preview);
